// extracted by mini-css-extract-plugin
export default {"zoomModal":"N1-z","image":"O1-z","button":"P1-z","isOverlayShown":"Q1-z"};